import React from 'react'
import './Cards1.css'

function cards1() {
  return (
    <div>
          
          <section className='box mt-5'>
 
            <div className='card1'>
                <h2 className='text-center'>600+ Users</h2>
            </div>

            <div className='card2'>
                <h2 className='text-center'>3000+ Views</h2>
            </div>

            <div className='card3'>
                <h2 className='text-center'>1000+ Clicks</h2>
            </div>
                

          </section>
           




    </div>
  )
}

export default cards1